import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {User} from "../../../model/user";
import {UserServiceService} from "../../../service/user-service.service";
import {Property} from "../../../model/property";
import {formatDate} from "@angular/common";
import {SignaturePadComponent} from "../../signature-pad/signature-pad.component";
import {SubauthorityData} from "../../../model/subauthorityData";
import * as $ from 'jquery';

/**
 * automatically generated subauthority with the opportunity to sign it.
 */
@Component({
  selector: 'app-subauthority-preview',
  templateUrl: './subauthority-preview.component.html',
  styleUrls: ['./subauthority-preview.component.css']
})
export class SubauthorityPreviewComponent implements OnInit, AfterViewInit {

  mobile: boolean = false;
  errorMsg: string;
  interest: string = "init";

  properties: Array<Property>
  subauthorityData: SubauthorityData
  user: User;

  @Output() authoritySigned: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @ViewChild(SignaturePadComponent) signaturePad: SignaturePadComponent;

  constructor(private userService: UserServiceService) {
    let obj = sessionStorage.getItem("user");
    if(obj)
      this.user = JSON.parse(obj);
  }

  ngOnInit(): void {
    let retrievedObject = sessionStorage.getItem('new_order_properties');
    this.properties = JSON.parse(retrievedObject);

    if (window.screen.width <= 1000) {
      this.mobile = true;
    }
    if (!this.user) {
      this.userService.getUser().subscribe(data => {
        this.user = data;
        this.initAuthData();
      });
    } else {
      this.initAuthData();
    }
  }

  ngAfterViewInit(): void{
    if (this.subauthorityData && this.subauthorityData.signingUrl)
      this.signaturePad.fromDataUrl(this.subauthorityData.signingUrl);
  }

  initAuthData(): void {
    let retrievedSubAuthority = sessionStorage.getItem('subAuthorityData');
    let signingDate;
    let signingURL = null;
    let date;
    let gesellschaft;
    let company;
    let person;
    let dauer;

    signingDate = this.user.town + ",den " + this.aktDate;
    if (retrievedSubAuthority != null) {
      let subauthority = JSON.parse(retrievedSubAuthority);
      if (subauthority.signingDate !== "")
        signingDate = subauthority.signingDate;
      if (subauthority.signingUrl !== "")
        signingURL = subauthority.signingUrl;
      if(subauthority.date != "")
        date = subauthority.date;
      if(subauthority.gesellschaft != "")
        gesellschaft = subauthority.gesellschaft;
      if(subauthority.company != "")
        company = subauthority.company
      if(subauthority.person != "")
        person = subauthority.person;
      if(subauthority.dauer != "")
        dauer = subauthority.dauer;
    }
    this.subauthorityData = new SubauthorityData(signingURL,signingDate,date,gesellschaft,company,person,dauer,this.interest,this.properties);

  }

  get aktDate() {
    return formatDate(new Date(), 'dd.MM.yyyy', 'en');
  }

  setAuthority(interest){
    let verifyPad = this.signaturePad.verifyPad("Bitte signieren Sie die Vollmacht");
    let subauthorityData = this.getSubAuthorityData(interest);
    if(!verifyPad){
      sessionStorage.setItem("subAuthorityData",JSON.stringify(subauthorityData));
      this.authoritySigned.emit();
    }
    else
      this.errorMsg = verifyPad;
  }

  getSubAuthorityData(interest){
    this.interest = interest;
    let signingDate = $("#sub-signing-date-input").val();
    let signingURL = this.signaturePad.toDataUrl();
    let date = $("#sub-date").val();
    let gesellschaft = $("#sub-gesellschaft").val()
    let company =  $("#sub-company").val();
    let person = $("#sub-company-person").val();
    let dauer = $("#sub-dauer").val();
    let subauthorityData = new SubauthorityData(signingURL,signingDate,date,gesellschaft,company,person,dauer,this.interest,this.properties)
    return subauthorityData;
  }

}
